type ClassValue = string | boolean | undefined | null;

/**
 * A simple utility for conditionally joining classNames together.
 * @param classes A list of class names. Falsy values are ignored.
 * @returns A string of space-separated class names.
 */
export function classNames(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ');
}
